<template>
  <page-outline :title="$t('annuaire.file_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>

        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="Annuaire">
          <div>
            <form-accordion :title="$t('tracking.details')" :isTitleUpperCase="false">
              <b-row class="form-group" v-if="Annuaire.FileName !== '' || Annuaire.DateImport !== '' || Annuaire.IdAnnuaire !== ''">
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Annuaire.FileName !== ''"
                    :inputLabel="$t('annuaire.file_name')" :inputValue="Annuaire.FileName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Annuaire.DateImport !== ''"
                    :inputLabel="$t('annuaire.date_import')" :inputValue="getDateDay(Annuaire.DateImport)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <label id="" class="">{{ $t('tracking.file') }}</label>
                  <div class="d-flex justify-content-start align-item-start">
                    <div>
                      <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeJson(Annuaire.IdAnnuaire, 'annuaire', 'see')"></i>
                    </div>
                    <div>
                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeJson(Annuaire.IdAnnuaire, 'annuaire', 'download')"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr />
          <!-- <div style="overflow:auto"> -->
          <div>
            <form-accordion :title="$t('tracking.lines')" :isTitleUpperCase="false">
              <b-table
                :hover="false"
                :items="Annuaire.Lines"
                :fields="fields"
                class="table table-striped" v-if="Annuaire.Lines && Annuaire.Lines.length"
                :selectable="false"
                responsive>

                <template #cell(Data)="data">
                  <div class="d-flex">

                    <div v-if="data.item.FirstName1 !== '' || data.item.LastName1 !== '' || data.item.MarriedName1 !== '' || data.item.BirthName1 !== ''">
                      <span>{{ $t('annuaire.label_pp_1')}}</span>
                      <table class="annuaireTable">
                        <tbody>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.first_name') }}:</th>
                          <td class="p-1" :title="data.item.FirstName1">{{ data.item.FirstName1 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.last_name') }}:</th>
                          <td class="p-1" :title="data.item.LastName1">{{ data.item.LastName1 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.birth_name') }}:</th>
                          <td class="p-1" :title="data.item.BirthName1">{{ data.item.BirthName1 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.married_name') }}:</th>
                          <td class="p-1" :title="data.item.MarriedName1">{{ data.item.MarriedName1 }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="data.item.FirstName2 !== '' || data.item.LastName2 !== '' || data.item.MarriedName2 !== '' || data.item.BirthName2 !== ''">
                      <span>{{ $t('annuaire.label_pp_2')}}</span>
                      <table class="ml-5 annuaireTable">
                        <tbody>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.first_name') }}:</th>
                          <td class="p-1" :title="data.item.FirstName2">{{ data.item.FirstName2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.last_name') }}:</th>
                          <td class="p-1" :title="data.item.LastName2">{{ data.item.LastName2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.birth_name') }}:</th>
                          <td class="p-1" :title="data.item.BirthName2">{{ data.item.BirthName2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.married_name') }}:</th>
                          <td class="p-1" :title="data.item.MarriedName2">{{ data.item.MarriedName2 }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="data.item.CompanyName !== '' || data.item.Siren !== '' || data.item.Siret !== '' || data.item.TVAIntracomm !== ''">
                      <span>{{ $t('annuaire.label_pm_1')}}:</span>
                      <table class="ml-5 annuaireTable" >
                        <tbody>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.company_name') }}:</th>
                          <td class="p-1" :title="data.item.CompanyName">{{ data.item.CompanyName }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.siren') }}:</th>
                          <td class="p-1" :title="data.item.Siren">{{ data.item.Siren }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.siret') }}:</th>
                          <td class="p-1" :title="data.item.Siret">{{ data.item.Siret }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.tva_intracomm') }}:</th>
                          <td class="p-1" :title="data.item.TVAIntracomm">{{ data.item.TVAIntracomm }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.trading_name') }}:</th>
                          <td class="p-1" :title="data.item.TradingName">{{ data.item.TradingName }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.lei') }}:</th>
                          <td class="p-1" :title="data.item.LEI">{{ data.item.LEI }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.euid') }}:</th>
                          <td class="p-1" :title="data.item.EUID">{{ data.item.EUID }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="data.item.CompanyName2 !== '' || data.item.Siren2 !== '' || data.item.Siret2 !== '' || data.item.TVAIntracomm2 !== ''">
                      <span>{{ $t('annuaire.label_pm_2')}}:</span>
                      <table class="ml-5 annuaireTable">
                        <tbody>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.company_name') }}:</th>
                          <td class="p-1" :title="data.item.CompanyName2">{{ data.item.CompanyName2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.siren') }}:</th>
                          <td class="p-1" :title="data.item.Siren2">{{ data.item.Siren2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.siret') }}:</th>
                          <td class="p-1" :title="data.item.Siret2">{{ data.item.Siret2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.tva_intracomm') }}:</th>
                          <td class="p-1" :title="data.item.TVAIntracomm2">{{ data.item.TVAIntracomm2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.trading_name') }}:</th>
                          <td class="p-1" :title="data.item.TradingName2">{{ data.item.TradingName2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.lei') }}:</th>
                          <td class="p-1" :title="data.item.LEI2">{{ data.item.LEI2 }}</td>
                        </tr>
                        <tr>
                          <th class="p-1">{{ $t('annuaire.euid') }}:</th>
                          <td class="p-1" :title="data.item.EUID2">{{ data.item.EUID2 }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>

                <template #cell(Status)="data">
                  <span>{{ $t('annuaire.status_'+data.value)}}</span>
                </template>

                <template #cell(Active)="data">
                  <span>{{ $t('annuaire.active_'+data.value)}}</span>
                </template>

                <template #cell(DateLastUpdate)="data">
                  <span>{{ getDateDay(data.item.DateLastUpdate) }}</span>
                </template>
              </b-table>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import moment from "moment-timezone";
import {DOMParser} from "xmldom";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'AnnuaireFileDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {

    fields () {
      let fields
      fields = [
        { key: 'IBAN', label: this.$i18n.t('annuaire.iban'), class: 'text-center', sortable: false },
        { key: 'Data', label: this.$i18n.t('annuaire.data'), class: 'text-center', sortable: false },
        { key: 'DateLastUpdate', label: this.$i18n.t('annuaire.date_last_update'), class: 'text-center', sortable: false },
        { key: 'Active', label: this.$i18n.t('annuaire.active'), class: 'text-center', sortable: false },
        { key: 'Status', label: this.$i18n.t('annuaire.status'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.firstOn().rights.rightIs('usercompany_delete', true) || this.$engine.firstOn().rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.firstOn().rights.rightIs('usercompany_edit', true) || this.$engine.firstOn().rights.rightIs('usercompany_edit_admin', true)
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return this.$t('annuaire.file_details')
    }
  },
  props: ['id', 'type'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '',
      Annuaire: {},
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.firstOn().settings.set({msgDirection: this.direction})
    this.getAnnuaire()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/tracking/BULKDETAILS/' + id})
    },
    seeTracksDetails (items) {
      this.activateDetail(items[0].IdVopMessageLineBulk)
    },
    getStatus(value, score) {
      if (value && score === 'MTCH') {
        return 'MTCH'
      } else if (value && score === 'NCTC') {
        return 'NCTC'
      } else if (value && score === 'NOAP') {
        return 'NOAP'
      } else if (value && score === 'CMTC'){
        return 'CMTC'
      } else {
        return null
      }
    },
    calculateStatuses(line) {
      // Définit les statuts pour chaque champ
      const statuses = {
        Name: this.getStatus(line.Name, line.NameScore),
        Siren: this.getStatus(line.Siren, line.SirenScore),
        Siret: this.getStatus(line.Siret, line.SiretScore),
        TVAIntracom: this.getStatus(line.TVAIntracom, line.TVAIntracomScore),
      }

      // Calcule le statut global
      const uniqueStatuses = new Set(Object.values(statuses))

      let globalStatus = null
      if (uniqueStatuses.has('NCTC')) {
        globalStatus = 'NCTC'
      } else if (uniqueStatuses.has('NOAP') || uniqueStatuses.has('CMTC')) {
        globalStatus = 'NOAP'
      } else {
        globalStatus = 'MTCH'
      }

      if (globalStatus === 'MTCH'){
        return "fa-solid fa-check text-success"
      }
      if (globalStatus === 'NCTC'){
        return "fa-solid fa-xmark text-danger"
      }
      if (globalStatus === 'NOAP'){
        return "fa-solid fa-triangle-exclamation text-warning"
      }
      if (globalStatus == null){
        return "fa-solid fa-ban"
      }
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.firstOn().tracking
          .getJSON({service, id})
          .then((resp) => {
            if (resp.data) {
              dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              dataDetails.type = service
              if (action === 'see') {
                that.$bus.emit('popup-json-details', dataDetails)
              } else {
                //download file
                let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
                if (this.isCSV(data)){
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
                  const blob = new Blob([data], { type: 'text/csv' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
                }
              }
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
    },
    getDateDay(date){
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss');
    },
    getDate(date){
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    defineReturnURL() {
      this.returnUrl =  '/annuaire/2'
    },
    getAnnuaire () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      this.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAnnuaire: this.id,
        ByClient: 0
      }
      this.$engine.firstOn().annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.annuaires && resp.data.annuaires.length) {
          that.Annuaire = resp.data.annuaires[0]
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    }
  }
}
</script>
